/* eslint-disable no-undef */
import request from '@utils/request';

export const wxConfig = () => {
  return new Promise((resolve, reject) => {
    request
      .post('/growth/common/baseinfo', {
        url: window.location.href.split('#')[0]
      })
      .then(res => {
        if (res) {
          wx.config({
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'getLocation']
          });
          // 用iframe打开的h5需要加这个， 否则会导致页面打不开（比如速运+小程序里的页面）
          if (window.self !== window.top) {
            wx.complete(function(info) {
              console.log(info);
            });
          }
          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: ['getLocation', 'onMenuShareAppMessage', 'onMenuShareTimeline'],
              success: function() {
                console.log('定位、分享校验成功');
              }
            });
            wx.error(function(res) {
              reject('微信异常');
              console.log('wx.error -->', res);
            });
            resolve();
          });
        }
      });
  });
};

// 获取图形验证码
export const getCaptcha = () => request.get('/market/activity/common/getcaptcha');

// 获取短信验证码
export const getCode = params => request.post('/market/activity/common/getsmscode', params);
